import React from 'react';
import changeProviderProvider from 'mn-utils/changeProviderProvider';
import handleProviderProvider from 'mn-utils/changeProviderProviderSimple';
import map from 'mn-utils/map';
import trim from 'mn-utils/trim';
import find from 'mn-utils/find';
import reduce from 'mn-utils/reduce';
import forEach from 'mn-utils/forEach';
import isEqual from 'mn-utils/isEqual';
import toLower from 'mn-utils/toLower';
import isASCII from 'mn-utils/isASCII';
import CancelablePromise from 'mn-utils/CancelablePromise';
import DeleteIcon from '@material-ui/icons/Delete';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import withState from '../../../../../../../utils/withState';
import validateUrlWithHttps from '../../../../../../../utils/validateUrlWithHttps';
import {
  apiAppEdit,
  apiAppNotificationHeaderEdit,
  apiAppNotificationHeaderAdd,
  apiAppNotificationHeaderRemove,
} from '../../../../../../../api/merchant/app';
import {
  updateWdgets,
} from '../../../../../../../emitters/widgets';
import {
  openPopupInfo,
} from '../../../../../../../emitters/popup';
import {
  DisplayDataMerchant,
} from '../../../../../../dumb/DisplayData';

import SwitchD from '../../../../../../dumb/Switch/D';
import TextField from '../../../../../../dumb/TextField/I';
import ButtonAccept from '../../../../../../dumb/Button/Accept';
import Button from '../../../../../../dumb/Button/C';

import AuthField from './AuthField';

import normalizeAuth from './utils/normalizeAuth';
import appGet from './utils/appGet';

const AUTH_TYPE_BASIC = 'Basic';
const AUTH_TYPE_BEARER = 'Bearer';
const AUTH_TYPES = [
  AUTH_TYPE_BASIC,
  AUTH_TYPE_BEARER,
];
const PROXY_AUTH_TYPES = [
  AUTH_TYPE_BASIC,
];

function apiAppSave(params, prev) {
  const {
    app_id: appId,
    notification_settings: notificationSettings,
  } = params;
  const _notificationSettings = {
    ...notificationSettings,
  };

  delete _notificationSettings.headers;

  const promises = [];

  isEqual(_notificationSettings, {
    awaiting_confirmation_disabled: !prev.awaitingConfirmationEnabled,
    expired_disabled: !prev.expiredEnabled,
    callback_enabled: prev.defaultCallbackUrlEnabled,
    callback_url: prev.defaultCallbackUrl,
    auth: prev.auth,
    proxy_auth: prev.proxyAuth,
  }, 3) || promises.push(apiAppEdit({
    id: appId,
    notification_settings: _notificationSettings,
  }).finally(updateWdgets));

  let prevHeaders = prev.headers;
  forEach(notificationSettings.headers, (header) => {
    const id = header.id;
    if (!id) {
      promises.push(apiAppNotificationHeaderAdd({
        app_id: appId,
        ...header,
      }));
      return;
    }

    let _prevHeader;
    prevHeaders = reduce(prevHeaders, (a, prevHeader) => {
      (id === prevHeader.id)
        ? (_prevHeader = prevHeader)
        : a.push(prevHeader);
      return a;
    }, []);

    if (
      _prevHeader && (
        toLower(_prevHeader.name) !== toLower(header.name)
        || _prevHeader.value !== header.value
      )
    ) {
      promises.push(apiAppNotificationHeaderEdit(header));
    }
  });
  forEach(prevHeaders, (header) => {
    promises.push(apiAppNotificationHeaderRemove({
      id: header.id,
    }));
  });
  return CancelablePromise.all(promises);
}

function isInvalidAuth(auth) {
  auth = normalizeAuth(auth);
  if (!auth.enabled) {
    return false;
  }
  const type = auth.type;
  if (type) {
    return type === AUTH_TYPE_BASIC
      ? !auth.username
      : !auth.token;
  }
  return true;
}
function Switch(props) {
  return (
    <SwitchD
      {...props}
      className={'cDADCE1 ' + (props.className || '')}
      label={(<div
        className="c0 f15 fw5"
      >{props.label}</div>)}
    />
  );
}


module.exports = withState((setState, self, onMount) => {
  self.state = {
    loading: true,
  };
  let _lastId = 0;
  const changeProvider = changeProviderProvider(setState);
  const handleProvider = handleProviderProvider(setState);

  onMount(() => {
    setState({
      ...self.props.data,
      prev: self.props.prev,
    });
  });

  return (state, props) => {
    const {
      clicked,
    } = state;

    const awaitingConfirmationEnabled = state.awaitingConfirmationEnabled || false;
    const expiredEnabled = state.expiredEnabled || false;
    const defaultCallbackUrlEnabled = state.defaultCallbackUrlEnabled || false;
    const defaultCallbackUrl = state.defaultCallbackUrl || '';
    const _defaultCallbackUrl = trim(defaultCallbackUrl);
    const headers = state.headers || [];
    const auth = state.auth || {};
    const proxyAuth = state.proxyAuth || {};


    const invalidHeaders = !!find(headers, (header) => {
      const _name = trim(header.name);
      const _value = trim(header.value);
      const invalidName = !_name || !isASCII(_name);
      const invalidValue = !_value || !isASCII(_value);
      return invalidName || invalidValue;
    });

    const invalidDefaultCallbackUrl = defaultCallbackUrlEnabled
      && !validateUrlWithHttps(_defaultCallbackUrl);
    const disabled = invalidHeaders || invalidDefaultCallbackUrl
      || isInvalidAuth(auth)
      || isInvalidAuth(proxyAuth);

    return (
      <>
        <div className="layoutRow fhaS fvaS c0 f16 fw7 lts0em lh24 h24 ws">
          <DisplayDataMerchant>{state.website || ''}</DisplayDataMerchant>
        </div>
        <div className="mt4 c717275 f12 lh17 fw3 lts0em layoutRow fhaS fvaS">
          <DisplayDataMerchant>{props.appId}</DisplayDataMerchant>
        </div>
        <div className="mt50">
          <div className="f15 fw5 mb15">
            Notifications about changes in the status of payments
          </div>
          <SwitchD
            label={`I want to be notified about the status "awaiting_payment_confirmation"`}
            checked={awaitingConfirmationEnabled}
            onChange={handleProvider('awaitingConfirmationEnabled')}
          />
          <SwitchD
            label={`I want to be notified about the status "expired"`}
            checked={expiredEnabled}
            onChange={handleProvider('expiredEnabled')}
          />

          <Switch
            className="mt50"
            label="Main callback URL"
            checked={defaultCallbackUrlEnabled}
            onChange={handleProvider('defaultCallbackUrlEnabled')}
          />
          <div
            className={'dn o50 o100.enabled'
              + (defaultCallbackUrlEnabled ? ' enabled' : '')}
          >
            <div className="mt20">
              <TextField
                label="URL (only https)"
                error={clicked && invalidDefaultCallbackUrl}
                value={defaultCallbackUrl}
                onChange={changeProvider('defaultCallbackUrl')}
                helperText={invalidDefaultCallbackUrl ? 'Invalid URL' : ''}
                maxLength={250}
                disabled={!defaultCallbackUrlEnabled}
              />
            </div>
            <AuthField
              className="mt50"
              label="Authorization"
              clicked={clicked}
              value={auth}
              items={AUTH_TYPES}
              onChange={handleProvider('auth')}
              disableFullBlock={!defaultCallbackUrlEnabled}
              maxLength={250}
            />
            <AuthField
              className="mt50"
              label="Proxy-Authorization"
              clicked={clicked}
              value={proxyAuth}
              items={PROXY_AUTH_TYPES}
              disabledSelect
              onChange={handleProvider('proxyAuth')}
              disableFullBlock={!defaultCallbackUrlEnabled}
              maxLength={250}
            />
            <div className="f15 fw5 mt50">Headers</div>
            <div className="mt20">
              {map(headers, (header, i) => {
                const {
                  name,
                  value,
                } = header;

                const changeChildProvider = changeProviderProvider((next) => {
                  const _headers = [...headers];
                  _headers[i] = {
                    ...header,
                    ...next,
                  };
                  setState({
                    headers: _headers,
                  });
                });

                const _name = trim(name);
                const _value = trim(value);
                const invalidName = !_name || !isASCII(_name);
                const invalidValue = !_value || !isASCII(_value);

                return (
                  <div
                    key={header.id || header._id}
                    className="layoutRow fhaS fvaC bs bcF2 b bt1
                      (bt|pt):first pb:last pv10"
                  >
                    <div className="layoutRow fhaS fvaC w1/2>1 fx1">
                      <div>
                        <TextField
                          label="Name"
                          value={name}
                          onChange={changeChildProvider('name')}
                          error={clicked && invalidName}
                          helperText={invalidName ? 'Must be ASCII characters' : ''}
                          disabled={!defaultCallbackUrlEnabled}
                          maxLength={250}
                        />
                      </div>
                      <div className="pl10">
                        <TextField
                          label="Value"
                          value={value}
                          onChange={changeChildProvider('value')}
                          error={clicked && invalidValue}
                          helperText={invalidValue ? 'Must be ASCII characters' : ''}
                          disabled={!defaultCallbackUrlEnabled}
                          maxLength={250}
                        />
                      </div>
                    </div>
                    <div className="pl10">
                      <Button
                        onClick={() => {
                          const _headers = [...headers];
                          _headers.splice(i, 1);
                          setState({
                            headers: _headers,
                          });
                        }}
                        disabled={!defaultCallbackUrlEnabled}
                      >
                        <DeleteIcon/>
                      </Button>
                    </div>
                  </div>
                );
              }, [])}
            </div>
            <div className="mt20">
              <Button
                onClick={() => {
                  setState({
                    headers: [
                      ...headers,
                      {
                        _id: ++_lastId,
                        name: '',
                        value: '',
                      },
                    ],
                  });
                }}
                disabled={!defaultCallbackUrlEnabled}
              >
                <AddCircleOutlineIcon/>
                <div className="pl10">Add</div>
              </Button>
            </div>
            <div className="pt90 layoutRow fhaB fvaC">
              <ButtonAccept
                disabled={disabled && clicked}
                onClick={() => {
                  if (disabled) {
                    setState({
                      clicked: true,
                    });
                    return;
                  }
                  setState({
                    loading: true,
                  });

                  appGet({
                    id: props.appId,
                  }).finally((error) => {
                    if (error) {
                      props.setParentErrorState && props.setParentErrorState(error);
                      return;
                    }

                    apiAppSave({
                      app_id: props.appId,
                      notification_settings: {
                        awaiting_confirmation_disabled: !awaitingConfirmationEnabled,
                        expired_disabled: !expiredEnabled,
                        callback_enabled: defaultCallbackUrlEnabled,
                        callback_url: _defaultCallbackUrl,
                        auth: normalizeAuth(auth, defaultCallbackUrlEnabled),
                        proxy_auth: normalizeAuth(proxyAuth, defaultCallbackUrlEnabled),
                        headers: defaultCallbackUrlEnabled
                          ? map(headers, (header) => {
                            const id = header.id;
                            const _header = {
                              name: trim(header.name),
                              value: trim(header.value),
                            };
                            id && (_header.id = id);
                            return _header;
                          }) : [],
                      },
                    }, state.prev).finally((error) => {
                      error || openPopupInfo([
                        'Notification settings',
                        'Settings have been saved',
                      ]);
                      // updateBase();
                    });
                  });
                }}
              >Save changes</ButtonAccept>
            </div>
          </div>
        </div>
      </>
    );
  };
});
